import Component from 'vue-class-component';

/**
 * Global registration of hooks
 */
Component.registerHooks([
  'metaInfo',
  'beforeRouteLeave',
]);
